/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 3058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C_: function() { return /* binding */ o; },
/* harmony export */   Td: function() { return /* binding */ h; },
/* harmony export */   hj: function() { return /* binding */ a; },
/* harmony export */   yu: function() { return /* binding */ d; }
/* harmony export */ });
/* unused harmony export ScrollSnapPlugin */
var i = class {
    slider;
    constructor() {
      this.slider = null;
    }
  },
  o = class extends i {
    intervalDuration;
    timeoutDuration;
    debounceId;
    interval;
    events;
    constructor(e = 3141, t = 6282, s = ["touchmove", "wheel"]) {
      super(), this.intervalDuration = e, this.timeoutDuration = t, this.interval = null, this.events = s;
    }
    get id() {
      return "ScrollSnapAutoplay";
    }
    enable = () => {
      this.debounceId && clearTimeout(this.debounceId), this.debounceId = null, this.interval = setInterval(this.onInterval, this.intervalDuration);
      for (let e of this.events) this.slider.addEventListener(e, this.disableTemporarily, {
        passive: !0
      });
    };
    disable() {
      for (let e of this.events) this.slider.removeEventListener(e, this.disableTemporarily);
      this.interval && clearInterval(this.interval), this.interval = null, this.debounceId && clearTimeout(this.debounceId), this.debounceId = null;
    }
    disableTemporarily = () => {
      this.interval && (clearInterval(this.interval), this.interval = null, this.debounceId && clearTimeout(this.debounceId), this.debounceId = setTimeout(this.enable, this.timeoutDuration));
    };
    onInterval = () => {
      if (this.slider.plugins.has("ScrollSnapLoop")) {
        this.slider.slideTo(this.slider.slide + 1);
        return;
      }
      requestAnimationFrame(() => {
        let {
            scrollLeft: e,
            offsetWidth: t,
            scrollWidth: s
          } = this.slider.element,
          n = e + t === s ? 0 : this.slider.slide + 1;
        this.slider.slideTo(n);
      });
    };
  },
  d = class extends i {
    quickSwipeDistance;
    lastX;
    startX;
    constructor(e = null) {
      super(), this.lastX = null, this.startX = null, this.slider = null, this.quickSwipeDistance = e;
    }
    get id() {
      return "ScrollSnapDraggable";
    }
    enable() {
      this.slider.element.classList.add("-draggable"), this.slider.addEventListener("mousedown", this.startDragging), addEventListener("mouseup", this.stopDragging, {
        capture: !0
      });
    }
    disable() {
      this.slider.element.classList.remove("-draggable"), this.slider.removeEventListener("mousedown", this.startDragging), removeEventListener("mouseup", this.stopDragging, {
        capture: !0
      }), this.lastX = null;
    }
    onSlideStopAfterDrag = () => {
      this.slider.element.style.scrollSnapStop = "", this.slider.element.style.scrollSnapType = "";
    };
    getFinalSlide() {
      if (!this.quickSwipeDistance) return this.slider.slide;
      let e = Math.abs(this.startX - this.lastX),
        t = this.quickSwipeDistance > e,
        s = e > this.slider.itemSize / 2;
      return t || s ? this.slider.slide : this.startX < this.lastX ? this.slider.slide - 1 : this.slider.slide + 1;
    }
    mouseMove = e => {
      let t = this.lastX - e.clientX;
      this.lastX = e.clientX, requestAnimationFrame(() => {
        this.slider.element.scrollLeft += t;
      });
    };
    startDragging = e => {
      e.preventDefault(), this.slider.removeEventListener("slide-stop", this.onSlideStopAfterDrag), this.startX = this.lastX = e.clientX, this.slider.element.style.scrollBehavior = "auto", this.slider.element.style.scrollSnapStop = "unset", this.slider.element.style.scrollSnapType = "none", this.slider.element.classList.add("-dragging");
      let t = this.slider.plugins.get("ScrollSnapAutoplay");
      t && t.disable(), addEventListener("mousemove", this.mouseMove);
    };
    stopDragging = e => {
      if (this.lastX === null) return;
      e.preventDefault();
      let t = this.getFinalSlide();
      removeEventListener("mousemove", this.mouseMove), this.lastX = null, this.slider.element.style.scrollBehavior = "", this.slider.element.classList.remove("-dragging"), this.slider.slideTo(t);
      let s = this.slider.plugins.get("ScrollSnapAutoplay");
      s && s.enable(), requestAnimationFrame(() => {
        let {
          scrollLeft: r,
          offsetWidth: n,
          scrollWidth: u
        } = this.slider.element;
        if (r === 0 || u - r - n === 0) {
          this.onSlideStopAfterDrag();
          return;
        }
        this.slider.addEventListener("slide-stop", this.onSlideStopAfterDrag, {
          once: !0
        });
      });
    };
  },
  h = class extends i {
    get id() {
      return "ScrollSnapLoop";
    }
    enable() {
      this.slider.addEventListener("slide-pass", this.loopSlides), this.slider.addEventListener("slide-stop", this.loopSlides), this.loopSlides();
    }
    disable() {
      this.slider.removeEventListener("slide-pass", this.loopSlides), this.slider.removeEventListener("slide-stop", this.loopSlides);
      let e = this.slider.element.querySelectorAll("[data-index]"),
        t = Array.from(e).sort(this.sortFunction);
      Element.prototype.append.apply(this.slider.element, t);
    }
    removeSnapping() {
      this.slider.detachListeners(), this.slider.element.style.scrollBehavior = "auto", this.slider.element.style.scrollSnapStop = "unset", this.slider.element.style.scrollSnapType = "none";
    }
    addSnapping() {
      this.slider.element.style.scrollBehavior = "", this.slider.element.style.scrollSnapStop = "", this.slider.element.style.scrollSnapType = "", this.slider.attachListeners(), requestAnimationFrame(this.slider.update);
    }
    loopEndToStart() {
      requestAnimationFrame(() => {
        this.removeSnapping(), this.slider.element.prepend(this.slider.element.children[this.slider.element.children.length - 1]), this.slider.element.scrollLeft += this.slider.itemSize, this.addSnapping();
      });
    }
    loopStartToEnd() {
      requestAnimationFrame(() => {
        this.removeSnapping(), this.slider.element.append(this.slider.element.children[0]), this.slider.element.scrollLeft -= this.slider.itemSize, this.addSnapping();
      });
    }
    loopSlides = () => {
      this.slider.element.children.length < 3 || requestAnimationFrame(() => {
        let {
          scrollLeft: e,
          offsetWidth: t,
          scrollWidth: s
        } = this.slider.element;
        if (e < 5) {
          this.loopEndToStart();
          return;
        }
        s - e - t < 5 && this.loopStartToEnd();
      });
    };
    sortFunction(e, t) {
      return parseInt(e.dataset.index, 10) - parseInt(t.dataset.index, 10);
    }
  },
  a = class {
    element;
    plugins;
    removeEventListener;
    addEventListener;
    roundingMethod;
    scrollTimeout;
    itemSize;
    sizingMethod;
    slide;
    firstItemInView;
    lastItemInView;
    resizeObserver;
    scrollTimeoutId;
    slideScrollLeft;
    constructor(e) {
      Object.assign(this, {
        scrollTimeout: 100,
        roundingMethod: Math.round,
        sizingMethod: t => t.element.firstElementChild.nextElementSibling ? t.element.firstElementChild.nextElementSibling.offsetLeft - t.element.firstElementChild.offsetLeft : t.element.firstElementChild.offsetWidth,
        ...e
      }), this.scrollTimeoutId = null, this.firstItemInView = true, this.lastItemInView = false, this.addEventListener = this.element.addEventListener.bind(this.element), this.removeEventListener = this.element.removeEventListener.bind(this.element), this.plugins = new Map(), this.resizeObserver = new ResizeObserver(this.rafSlideSize), this.resizeObserver.observe(this.element);
      for (let t of this.element.children) this.resizeObserver.observe(t);
      this.rafSlideSize(), this.attachListeners();
    }
    with(e, t = !0) {
      for (let s of e) s.slider = this, this.plugins.set(s.id, s), t && s.enable();
      return this;
    }
    attachListeners() {
      this.addEventListener("scroll", this.onScroll, {
        passive: !0
      });
    }
    detachListeners() {
      this.removeEventListener("scroll", this.onScroll), this.scrollTimeoutId && clearTimeout(this.scrollTimeoutId);
    }
    slideTo = e => {
      requestAnimationFrame(() => {
        this.element.scrollTo({
          left: e * this.itemSize
        });
      });
    };
    destroy() {
      this.scrollTimeoutId && clearTimeout(this.scrollTimeoutId), this.detachListeners();
      for (let [e, t] of this.plugins) t.disable(), t.slider = null, this.plugins.delete(e);
    }
    update = () => {
      this.slide = this.roundingMethod(this.element.scrollLeft / this.itemSize), this.slideScrollLeft = this.slide * this.itemSize;
      this.firstItemInView = this.element.firstChild.getBoundingClientRect().left >= 0;
      this.lastItemInView = Math.floor(this.element.lastChild.getBoundingClientRect().right) <= this.element.getBoundingClientRect().right;
    };
    onScrollEnd = () => {
      requestAnimationFrame(() => {
        this.scrollTimeoutId = null, this.update(), this.dispatch("slide-stop", this.slide);
      });
    };
    rafSlideSize = e => {
      requestAnimationFrame(() => {
        this.itemSize = this.sizingMethod(this, e), this.update();
      });
    };
    dispatch(e, t) {
      return this.element.dispatchEvent(new CustomEvent(e, {
        detail: t
      }));
    }
    onScroll = () => {
      requestAnimationFrame(() => {
        let {
            scrollLeft: e
          } = this.element,
          t = this.roundingMethod(e / this.itemSize);
        if (this.scrollTimeoutId === null) {
          let s = e > this.slideScrollLeft ? 1 : -1;
          this.dispatch("slide-start", this.slide + s);
        }
        t !== this.slide && (this.update(), this.dispatch("slide-pass", this.slide)), this.scrollTimeoutId && clearTimeout(this.scrollTimeoutId), this.scrollTimeoutId = setTimeout(this.onScrollEnd, this.scrollTimeout);
      });
    };
  };


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
/* harmony import */ var _scrollsnap_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3058);

class ScrollSnapSlider extends HTMLUListElement {
  constructor() {
    super();
    this.prevButton = this.parentNode.querySelector(".slider-buttons .slider-button--prev");
    this.nextButton = this.parentNode.querySelector(".slider-buttons .slider-button--next");
    this.indicators = this.parentNode.querySelectorAll(".indicator");
    this.currentIndicator = this.parentNode.querySelector(".indicator .current-indicator");
    this.isAutoplay = (this.dataset.autoplay || "false") === 'true';
    this.isLoop = (this.dataset.loop || "false") === 'true';
    this.isDraggable = (this.dataset.draggable || "false") === 'true';
    this.autoplayInterval = this.dataset.autoplayInterval ? this.dataset.autoplayInterval : 3000;
    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }
  async init() {
    const sliderElement = this;
    const sliderSimple = new _scrollsnap_js__WEBPACK_IMPORTED_MODULE_0__/* .ScrollSnapSlider */ .hj({
      element: this
    });
    const draggablePlugin = new _scrollsnap_js__WEBPACK_IMPORTED_MODULE_0__/* .ScrollSnapDraggable */ .yu(70);
    const autoplayPlugin = new _scrollsnap_js__WEBPACK_IMPORTED_MODULE_0__/* .ScrollSnapAutoplay */ .C_(this.autoplayInterval);
    const loopPlugin = new _scrollsnap_js__WEBPACK_IMPORTED_MODULE_0__/* .ScrollSnapLoop */ .Td();
    this.slider = sliderSimple;
    draggablePlugin.slider = sliderSimple;
    autoplayPlugin.slider = sliderSimple;
    loopPlugin.slider = sliderSimple;
    this.prevButton?.addEventListener("click", () => {
      autoplayPlugin.disableTemporarily();
      sliderSimple.slideTo(sliderSimple.slide - 1);
    });
    this.nextButton?.addEventListener("click", () => {
      autoplayPlugin.disableTemporarily();
      sliderSimple.slideTo(sliderSimple.slide + 1);
    });
    for (const indicator of this.indicators) {
      indicator.addEventListener("click", function () {
        autoplayPlugin.disableTemporarily();
        const slideElementIndex = Array.prototype.slice.call(sliderElement.children).findIndex(item => item.dataset.index === indicator.dataset.index);
        sliderSimple.slideTo(slideElementIndex);
      });
    }
    this.slider.addEventListener("slide-stop", e => {
      this.updateSlideState(e);
      this.updateIndicator(e);
    });
    if (!this.isLoop || this.isDraggable) {
      this.slider.addEventListener("slide-stop", () => {
        this.prevButton?.removeAttribute('disabled');
        this.nextButton?.removeAttribute('disabled');
        if (sliderSimple.firstItemInView) {
          this.prevButton?.setAttribute('disabled', 'disabled');
        }
        if (sliderSimple.lastItemInView) {
          this.nextButton?.setAttribute('disabled', 'disabled');
        }
      });
    }
    if (this.isAutoplay) {
      this.enablePlugin(autoplayPlugin);
    }
    if (this.isLoop) {
      this.enablePlugin(loopPlugin);
    }
    if (this.isDraggable) {
      this.enablePlugin(draggablePlugin);
      if (this.isLoop) {
        this.disablePlugin(loopPlugin);
      }
      return;
    }
    this.disablePlugin(draggablePlugin);
  }
  enablePlugin(plugin) {
    plugin.enable();
    this.slider.plugins.set(plugin.id, plugin);
  }
  disablePlugin(plugin) {
    plugin.disable();
    this.slider.plugins.delete(plugin.id);
  }
  updateSlideState(event) {
    const children = event.target.children;
    if (!children || event.detail < 0 || event.detail >= children.length) {
      return;
    }
    for (let child of children) {
      child.classList.remove('-active');
    }
    children[event.detail].classList.add('-active');
  }
  updateIndicator(event) {
    const slideElementIndex = event.detail;
    const slideElement = event.target.children[slideElementIndex];
    for (const indicator of this.indicators) {
      const isActive = indicator.classList.toggle("-active", indicator.dataset.index === slideElement.dataset.index);
      if (isActive) {
        indicator.appendChild(this.currentIndicator);
      }
    }
  }
}
customElements.define('scroll-snap-slider', ScrollSnapSlider, {
  extends: 'ul'
});
}();
/******/ })()
;